import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";

const DNSPage: React.FC = () => {
    return (
        <Fragment>
            <Helmet>
                <title>DNS Solutions | AquarLabs</title>
                <meta name="description" content="Enterprise DNS management with AquarLabs. High-performance DNS hosting, DNSSEC, traffic management, and global load balancing for mission-critical applications." />
            </Helmet>
            <div className="about-page inner-page">
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                        <PageTitle pageTitle="DNS Solutions" pagesub="DNS" parentPage="Solutions" parentLink="/service" />
                        <section className="service-hero-section" style={{ padding: "80px 0", background: "linear-gradient(135deg, rgba(252, 144, 56, 0.1) 0%, rgba(0, 2, 15, 0.8) 100%)" }}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-8">
                                        <h1 style={{ fontSize: "3rem", marginBottom: "20px", color: "#fff" }}>DNS Solutions</h1>
                                        <p style={{ fontSize: "1.25rem", color: "rgba(255,255,255,0.8)", lineHeight: "1.8" }}>
                                            Power your digital infrastructure with enterprise-grade DNS. Lightning-fast resolution, global redundancy, and advanced traffic management for always-on availability.
                                        </p>
                                        <Link to="/contact-us" className="thm-btn agency-btn" style={{ marginTop: "30px", display: "inline-block" }}>
                                            <span className="text">Get Started</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section style={{ padding: "80px 0" }}>
                            <div className="container">
                                <span style={{ color: "#fc9038", fontSize: "14px", textTransform: "uppercase", letterSpacing: "2px" }}>Overview</span>
                                <h2 style={{ fontSize: "2.5rem", margin: "15px 0 30px", color: "#fff" }}>Enterprise-Grade DNS Infrastructure</h2>
                                <p style={{ fontSize: "1.1rem", lineHeight: "1.8", color: "rgba(255,255,255,0.8)" }}>
                                    AquarLabs' DNS solutions provide ultra-fast, reliable name resolution backed by a globally distributed anycast network. With advanced features like geo-based routing, DNSSEC, and real-time analytics, we ensure your applications are always accessible and secure.
                                </p>
                            </div>
                        </section>
                        <section style={{ padding: "80px 0", background: "rgba(0,2,15,0.3)" }}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <span style={{ color: "#fc9038", fontSize: "14px", textTransform: "uppercase" }}>Capabilities</span>
                                        <h2 style={{ fontSize: "2rem", margin: "15px 0", color: "#fff" }}>Complete DNS Platform</h2>
                                    </div>
                                    <div className="col-lg-8">
                                        <div className="row">
                                            {[
                                                { title: "Managed DNS", desc: "High-performance hosting with 100% uptime SLA and instant propagation." },
                                                { title: "Traffic Management", desc: "Geo-routing, failover, and weighted load balancing for optimal performance." },
                                                { title: "DNSSEC", desc: "Cryptographic security to protect against DNS spoofing attacks." },
                                                { title: "DNS Analytics", desc: "Real-time query analytics and threat intelligence dashboards." }
                                            ].map((item, index) => (
                                                <div key={index} className="col-md-6" style={{ marginBottom: "30px" }}>
                                                    <div style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: "12px", padding: "30px", height: "100%" }}>
                                                        <h3 style={{ fontSize: "1.25rem", color: "#fff", marginBottom: "15px" }}><span style={{ color: "#fc9038" }}>●</span> {item.title}</h3>
                                                        <p style={{ fontSize: "0.95rem", color: "rgba(255,255,255,0.7)" }}>{item.desc}</p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section style={{ padding: "80px 0", background: "linear-gradient(135deg, rgba(252, 144, 56, 0.1) 0%, rgba(0, 2, 15, 0.5) 100%)" }}>
                            <div className="container text-center">
                                <h2 style={{ fontSize: "2.5rem", color: "#fff", marginBottom: "20px" }}>Upgrade Your DNS Infrastructure</h2>
                                <Link to="/contact-us" className="thm-btn agency-btn"><span className="text">Contact Us Today</span></Link>
                            </div>
                        </section>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default DNSPage;
